import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import InputLabel from '@mui/material/InputLabel';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { TypeAnimation } from 'react-type-animation';

import { visuallyHidden } from '@mui/utils';
import { styled } from '@mui/material/styles';



const StyledBox = styled('div')(({ theme }) => ({
  alignSelf: 'center',
  width: '100%',
  height: 400,
  marginTop: theme.spacing(8),
  borderRadius: theme.shape.borderRadius,
  outline: '6px solid',
  outlineColor: 'hsla(220, 25%, 80%, 0.2)',
  border: '1px solid',
  borderColor: theme.palette.grey[200],
  boxShadow: '0 0 12px 8px hsla(220, 25%, 80%, 0.2)',
  backgroundImage: `url(${'https://mui.com/static/screenshots/material-ui/getting-started/templates/dashboard.jpg'})`,
  backgroundSize: 'cover',
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(10),
    height: 700,
  },
  ...theme.applyStyles('dark', {
    boxShadow: '0 0 24px 12px hsla(210, 100%, 25%, 0.2)',
    backgroundImage: `url(${'https://mui.com/static/screenshots/material-ui/getting-started/templates/dashboard-dark.jpg'})`,
    outlineColor: 'hsla(220, 20%, 42%, 0.1)',
    borderColor: theme.palette.grey[700],
  }),
}));

export default function Hero({ requestADemo }) {
    const [email, setEmail] = React.useState("");
    const [demoRequested, setDemoRequested] = React.useState(false);

    return (
        <Box
            id="hero"
            sx={(theme) => ({
                width: '100%',
                backgroundRepeat: 'no-repeat',
                backgroundImage: 'radial-gradient(ellipse 80% 100% at 50% -20%, hsl(27, 100%, 50%), transparent)',
                ...theme.applyStyles(
                    'dark',
                    { backgroundImage: 'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(100, 100%, 16%), transparent)', }
                ),
            })}
        >
            <Container
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    pt: { xs: 14, sm: 20 },
                    pb: { xs: 8, sm: 12 },
                }}
            >
                <Stack
                    spacing={2}
                    useFlexGap
                    sx={{
                        //alignItems: 'center',
                        //width: { xs: '100%', sm: '70%' }
                        paddingTop: '0rem',
                        paddingRight : '4rem',
                    }}
                >
                    <Typography
                        variant="h1"
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            //alignItems: 'center',
                            fontSize: '4rem',
                            color : 'white',
                            textAlign : 'left',
                        }}
                    >
                        Light up your business
                        {/* Your corporation,<br/>demystified */}
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: 'left',
                            //color: 'text.secondary',
                            color: 'white',
                            width: { sm: '100%', md: '80%' },
                            fontSize : '1.4rem',
                        }}
                    >
                        Our next-generation AI enables companies with 1000+ headcount to
                        deeply understand the performance of every organizational unit
                        and make profitable decisions. Optimize the teams that deliver and
                        eliminate 100% of your cost centers.
                    </Typography>
                    <Paper
                        style={{
                            marginTop: '16px',
                            padding : '10px',
                        }}
                    >
                        {!demoRequested
                            ? <Stack direction='row' spacing={2} useFlexGap>
                                <TextField
                                    //ref={inputRef}
                                    size="large"
                                    variant="outlined"
                                    placeholder="Your email address"
                                    fullWidth
                                    inputProps={{ style : { fontSize: '1.25rem'} }}
                                    InputLabelProps={{ style : { fontSize: '1.25rem'} }}
                                    value={email}
                                    onChange={(event) => { setEmail(() => event.target.value); }}
                                />
                                <Button
                                    variant="outlined"
                                    size="large"
                                    sx={{
                                        minWidth: 'fit-content',
                                        fontSize: '1.25rem',
                                        backgroundColor: '#111',
                                        color: '#eee',
                                        paddingTop: 0,
                                        paddingBottom : 0,
                                    }}
                                    onClick={() => {
                                        if (email != null && email.length >= 3) {
                                            requestADemo();
                                            setDemoRequested(() => true);
                                        }
                                    }}
                                >
                                    Request a demo
                                </Button>
                            </Stack>
                            : <Stack direction='row' spacing={2} useFlexGap style={{ textAlign: 'center', alignItems: 'center' }}>
                                <Typography variant="body1" style={{ fontSize : '1.1rem', paddingLeft : '1rem' }}>
                                    Thank you for your interest. A member of our sales team will be in touch with you shortly.
                                </Typography>
                            </Stack>
                        }
                    </Paper>
                    {/*
                    <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={1}
                        useFlexGap
                        sx={{ pt: 2, width: { xs: '100%', sm: '350px' } }}
                        style={{
                            ba
                        }}
                    >
                        <InputLabel htmlFor="email-hero" sx={visuallyHidden}>
                            Email
                        </InputLabel>
                        <TextField
                            id="email-hero"
                            hiddenLabel
                            size="small"
                            variant="outlined"
                            aria-label="Enter your email address"
                            placeholder="Your email address"
                            fullWidth
                            slotProps={{
                                htmlInput: {
                                   autoComplete: 'off',
                                       'aria-label': 'Enter your email address',
                                },
                            }}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            sx={{ minWidth: 'fit-content' }}
                        >
                            Request a demo
                        </Button>
                    </Stack>
                    <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ textAlign: 'center' }}
                    >
                        By clicking &quot;Start now&quot; you agree to our&nbsp;
                        <Link href="#" color="primary">
                            Terms & Conditions
                        </Link>
                        .
                    </Typography>
                    */}
                </Stack>
                <Stack
                    spacing={2}
                    useFlexGap
                    style={{ paddingTop: '3rem' }}
                >
                    <Paper
                        elevation={15}
                        style={{ width: '350px', minHeight: '512px' }}
                    >
                        <Stack direction='column'>

                            <Stack
                                direction='row'
                                style={{ padding : '8px' }}
                            >
                                <Box style={{ padding: '4px', }}>
                                    <Avatar
                                        src="/orangevulpes.jpg"
                                        style={{
                                            border: '1px solid #aaa',
                                        }}
                                    />
                                </Box>
                                <Stack style={{ paddingLeft: '1rem' }}>
                                    <Box style={{
                                        fontSize: '1.5rem',
                                        fontWeight: 700,
                                        lineHeight: '1.5rem',
                                    }}>
                                        Koppleman-Katz, Intl.
                                    </Box>
                                    <Box style={{
                                        textAlign: 'left',
                                        fontSize: '1rem',
                                    }}>
                                        Executive AI
                                    </Box>
                                </Stack>
                            </Stack>

                            <Divider />

                            <Box style={{
                                fontSize : '1.2rem',
                                padding: '1rem',
                                textAlign: 'left',
                                fontWeight : 500,
                                color: 'hsl(0, 0%, 20%)'
                            }}>
                                Summarize the effect that the new Sr.
                                director of IT, A. Parker, has had on online
                                pet food sales in US, Mexico
                            </Box>

                            <Divider />

                            <Box style={{
                                //width: '300px',
                                padding : '1rem',
                                color : 'purple',
                                textAlign : 'center',
                            }}>
                                <TypeAnimation
                                    sequence={[
                                        // Same substring at the start will only be typed out once, initially
                                        'Since assuming the position on Oct 12, sales in the U.S. market have increased by 28%, but declined in the Mexico market by 13%.\n',
                                        4000,
                                        'U.S. and Mexico sales report generated and emailed to katz@koppkatz.com',
                                        2000,
                                        'The change correlates strongly with the launch of a new e-commerce website.',
                                        4000,
                                        'Since the Mexico market sales decline was reported, the e-commerce software team under A. Parker has had 2 employees with title "Web Designer" terminated, and 1 new employee with title "Software Architect" hired',
                                        3000,
                                        'The e-commerce software team has 37 work items with the keywords "language", "translation", and "adjust copy"',
                                        6000,
                                        '',
                                        3000,
                                    ]}
                                    wrapper="span"
                                    speed={80}
                                    style={{
                                        fontSize: '1.5em',
                                        display: 'inline-block',
                                        textAlign: 'left',
                                    }}
                                    repeat={Infinity}
                                    omitDeletionAnimation
                                />
                            </Box>

                            <Box style={{
                                fontSize : '1.2rem',
                                padding: '1rem',
                                textAlign: 'left',
                                fontWeight : 500,
                                color: 'hsl(0, 0%, 20%)'
                            }}>
                                <TypeAnimation
                                    sequence={[
                                        // Same substring at the start will only be typed out once, initially
                                        4000,
                                        'email me a report, and continue',
                                        1500,
                                        '',
                                        6000,
                                        'what actions has Parker taken?',
                                        1500,
                                        '',
                                        6000,
                                        'what else?',
                                        1000,
                                        '',
                                        4000,
                                        'save this conversation and remind me tomorrow',
                                        1000,
                                        '',
                                        4000,
                                    ]}
                                    wrapper="span"
                                    speed={60}
                                    style={{
                                        fontSize: '1.4em',
                                        display: 'inline-block',
                                        textAlign: 'left',
                                    }}
                                    repeat={Infinity}
                                    omitDeletionAnimation
                                />
                            </Box>

                        </Stack>
                    </Paper>
                </Stack>
            </Container>
            {/*<StyledBox id="image" />*/}
        </Box>
    );
}
